import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavigationViewComponent } from './components/side-navigation-view/side-navigation-view.component';
import { SideNavigationBaseMenuComponent } from './components/side-navigation-base-menu/side-navigation-base-menu.component';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [SideNavigationViewComponent, SideNavigationBaseMenuComponent],
  imports: [CommonModule, RouterModule, MatRippleModule, MatTooltipModule, AngularSvgIconModule],
  exports: [SideNavigationViewComponent]
})
export class SideNavigationModule {}
